module.exports = __webpack_public_path__ + "static/media/p2p.f370e9ff.svg";